import { useRef, useState } from "react";
import { ScanBarcode } from "lucide-react";

// USB/Bluetooth okuyucu klavye gibi yazar ve Enter gönderir. Odak korunur; her okutma onScan(code) çağırır.
export default function ScanBox({ onScan, disabled, testid = "scan-input", placeholder = "Barkod okutun veya SKU yazıp Enter…" }) {
  const [v, setV] = useState("");
  const [busy, setBusy] = useState(false);
  const ref = useRef(null);
  const submit = async (e) => {
    e.preventDefault();
    const code = v.trim();
    if (!code || busy) return;
    setBusy(true);
    try { await onScan(code); } finally { setBusy(false); setV(""); ref.current?.focus(); }
  };
  return (
    <form onSubmit={submit} className="relative">
      <ScanBarcode className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-blue-600" />
      <input ref={ref} autoFocus value={v} onChange={(e) => setV(e.target.value)} disabled={disabled} placeholder={placeholder} data-testid={testid}
        className="h-12 w-full rounded-md border-2 border-blue-300 bg-white pl-11 pr-3 font-mono text-base focus:border-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-600/30 disabled:bg-slate-100" />
    </form>
  );
}

export const idem = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random()}`);
